export default class ChildField {
    constructor(element) {
        this.$element = $(element);
        this.$child = $(this.$element.data('childField'));
        this.$childContainer = $(this.$element.data('childContainer'));
        this.children = {};
        this.itemCls = 'js-item';
        this.template = this.$child.find('script[type="text/x-tmpl-jermes"]').html() ||
            `<option class="${this.itemCls}" value="__value__">__grouped____label__</option>`;
    }

    init() {
        this.$childContainer.hide();

        if (Object.keys(this.children).length > 0) {
            return;
        }

        $.getJSON(this.$element.data('childrenSource'), response => {
            this.children = response;

            for (let i in response) {
                if (response[i].length > 0) {
                    this.$childContainer.show();
                    break;
                }
            }

            this.updateOptionsTree();
        });

        this.$element.on('change.childField', (event, isInitial) => {
            this.updateOptionsTree();

            if (!isInitial) {
                this.$child.children(`.${this.itemCls}`).first().click();
            }
        });
    }

    updateOptionsTree() {
        let emptyLabel = this.template
            .replace('__value__', this.$element.val())
            .replace('__label__', 'Tutti i modelli')
            .replace('__grouped__', '');

        this.$child.children().each((i, el) => {
            if ($(el).hasClass(this.itemCls)) {
                $(el).remove();
            }
        });

        this.$child.append(emptyLabel);

        let currentChildren = this.children[this.$element.val()] || [];

        if (currentChildren.length === 0) {
            this.$childContainer.hide();
        } else {
            this.$child.removeAttr('disabled');
            this.$childContainer.show();
        }

        $.each(currentChildren, (index, el) => {
            let item = this.template
                .replace('__value__', el.value)
                .replace('__label__', el.label)
                .replace('__grouped__', el.grouped ? '&nbsp;&nbsp;&nbsp;&nbsp;' : '');
            this.$child.append(item);
        });

        // Select value in $child element if it is predefined in [data-children-value] of $element
        let childrenValue = this.$element.data('children-value');

        if (childrenValue) {
            this.$child.val(childrenValue);
            this.$element.removeProp('data-children-value');
            this.$element.removeAttr('data-children-value');
            this.$element.removeData('childrenValue');
        }

        this.$element.trigger('optionsTreeUpdate:finish');
    }
}
